var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import Vue from 'vue';
import { WalletsHelper } from "../../lib/storage";
import MessageModule from '../mixins/MessageModule';
export default Vue.extend({
    mixins: [MessageModule],
    name: "NavigationDrawer",
    props: {
        value: {
            type: Boolean,
            default: true
        },
    },
    data() {
        return {
            visible: this.value,
            items: [
                { title: 'Home', icon: 'icon_menu_home.png', action: this.closeDrawer },
                { title: this.$t('common.address_book'), icon: 'icon_menu_addressbook.png', action: this.showNotImplementedYet },
                { title: this.$t('common.mosaic_gallery'), icon: 'icon_menu_mosaic.png', action: this.goToMosaicGallery },
                { title: this.$t('common.donation'), icon: 'icon_menu_faucet.png', action: this.goToDonation },
                { title: '', icon: '', action: this.showNotImplementedYet },
                { title: 'About', icon: 'icon_menu_about.png', action: this.goToAboutThisApp },
                { title: 'Help', icon: 'icon_menu_help.png', action: this.jumpToHelp },
                { title: this.$t('common.settings'), icon: 'icon_menu_setting.png', action: this.goToSettings },
            ],
            right: null,
            walletName: '',
            walletAddress: ''
        };
    },
    methods: {
        closeDrawer() {
            this.visible = false;
        },
        showNotImplementedYet() {
            this.showError(this.$t('common.coming_soon').toString());
        },
        goToMosaicGallery() {
            this.$router.push('/gallery');
        },
        goToDonation() {
            this.$router.push('/donation/top');
        },
        jumpToHelp() {
            window.open('https://raccoonwallet.com/help/');
        },
        goToAboutThisApp() {
            this.$router.push('/about');
        },
        goToSettings() {
            this.$router.push('/settings/top');
        }
    },
    mounted() {
        return __awaiter(this, void 0, void 0, function* () {
            const wallet = yield WalletsHelper.getActive();
            if (wallet === null) {
                this.walletName = this.$t('common.not_select').toString();
                this.walletAddress = '';
            }
            else {
                this.walletName = wallet.name;
                this.walletAddress = wallet.address;
            }
        });
    },
    watch: {
        visible() {
            this.$emit('input', this.$data.visible);
        },
        value() {
            this.visible = this.value;
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/parts/NavigationDrawer.vue
// module id = 363
// module chunks = 1